/* The quiz bar on a product page (23 Sep 2026): sections/v4-product-quiz-bar.liquid.

   v4-quiz.js writes the result with a "Choose the ..." button to each light's own page. On the page
   of the light it recommends, that button would reload the page you are already on, which Josh ruled
   out for the sticky bar on 16 Sep: it glides back to the buy box instead. So here that one button
   closes the quiz and takes you up to the buy box, and focus goes there too, for keyboard and screen
   reader users. A button to either of the other two lights goes to its page as normal, and a Ctrl or
   middle click still opens a new tab. */
(function () {
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // The product's handle from a path, whether it is /products/x or /collections/y/products/x.
  function handle(path) {
    var m = /\/products\/([^\/?#]+)/.exec(path || '');
    return m ? decodeURIComponent(m[1]) : null;
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var link = event.target.closest ? event.target.closest('#category-quiz a[href]') : null;
    if (!link) return;
    var url;
    try { url = new URL(link.getAttribute('href'), window.location.href); } catch (e) { return; }
    var here = handle(window.location.pathname);
    if (url.origin !== window.location.origin || !here || handle(url.pathname) !== here) return;
    var buy = document.getElementById('p-buy');
    var dialog = document.getElementById('category-quiz');
    if (!buy || !dialog) return;
    event.preventDefault();
    if (dialog.open) dialog.close();
    buy.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
    if (!buy.hasAttribute('tabindex')) {
      buy.setAttribute('tabindex', '-1');
      buy.addEventListener('blur', function () { buy.removeAttribute('tabindex'); }, { once: true });
    }
    buy.focus({ preventScroll: true });
  });
})();
